import { render, staticRenderFns } from "./Skeleton.form.vue?vue&type=template&id=59bf0660&scoped=true&"
import script from "./Skeleton.form.vue?vue&type=script&lang=js&"
export * from "./Skeleton.form.vue?vue&type=script&lang=js&"
import style0 from "./Skeleton.form.vue?vue&type=style&index=0&id=59bf0660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf0660",
  null
  
)

export default component.exports